import type { ComponentProps } from 'react'
import { forwardRef } from 'react'
import { cn } from '@/lib/utils'

const Textarea = forwardRef<HTMLTextAreaElement, ComponentProps<'textarea'>>(
  ({ className, spellCheck = true, ...props }, ref) => {
    return (
      <div className="group relative w-full">
        <textarea
          spellCheck={spellCheck}
          className={cn(
            'rounded-control relative z-10 flex min-h-[80px] w-full resize-none border border-border/70 bg-transparent px-4 py-3 text-base text-foreground shadow-none outline-none md:text-sm',
            'placeholder:text-muted-foreground/60',
            'transition-colors duration-200 ease-out',
            'hover:border-border/90 focus:border-primary/80',
            'disabled:cursor-not-allowed disabled:opacity-50',
            className,
          )}
          ref={ref}
          {...props}
        />
      </div>
    )
  },
)
Textarea.displayName = 'Textarea'

export { Textarea }
